function createInitialState() {
    const initialState = {
        draftCategoryId: 0,
        draftCategoryPath: [],
        validationError: null
    };
    return initialState;
}

const initialState = createInitialState();

function validate(state) {
    if (!state.draftCategoryId || state.draftCategoryId === 0) {
        return {
            ...state,
            validationError: 'syi_validation_missing_category'
        };
    } else {
        return { ...state, validationError: null };
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RESET_CATEGORY': {
            return validate(createInitialState());
        }
        case 'SET_DRAFT_CATEGORY': {
            const newState = {
                ...state,
                draftCategoryId: action.categoryId,
                draftCategoryPath: action.categoryPath
            };
            return validate(newState);
        }
        default:
            return state;
    }
};
